import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { runInnerFunction } from "../../compatManager";
import { getDataReader, getNodes, RPWDataReader } from "../../livedataFuncs";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject } from "../../redux/reducer";
import { store } from "../../redux/store";
import Loading from "../Loading";
import { CreatePIPS, generatePdfPIPS, patchPipsIframeJQuery, removeHeaderFooter } from "./PipsFuncs";

async function initPips(sid: string, livedataRoot): Promise<string> {
    let node: ajaxslt.XNode[] = getNodes(livedataRoot, 'TPAppXML');
    let pipformid: string = await CreatePIPS(sid, node[0]);
    return pipformid;

}

async function login(iframe: HTMLIFrameElement, username: string, teraviewNumber: string, setAttemptedLogin: (flag: boolean) => void): Promise<void>{
    let iDocument = null;
    if (iframe !== null && iframe !== undefined) {
        iDocument = iframe.contentWindow.document;
        let usernameField = iDocument.getElementById('j_username');
        let tvNumberField = iDocument.getElementById('j_tvnumber');
        if ((usernameField !== null && usernameField !== undefined) || (tvNumberField !== null && tvNumberField !== undefined)) { // account login name or tv number field is on the screen
            if (username > '' && teraviewNumber > '') {
                usernameField.value = username;
                tvNumberField.value = teraviewNumber;
                let loginbtn = iDocument.getElementById('btn-login');
                loginbtn.click(); // login 
                setAttemptedLogin(true);
            }
        }
    }
}

function saveAndExit(iframe: HTMLIFrameElement) : void{ // press save and exit on screen
    if (iframe !== null && iframe !== undefined) {
        var buttonsArray: any = iframe.contentDocument.querySelectorAll('Button');
        for (let i = 0; i < buttonsArray.length; i++) {
            if (buttonsArray[i].innerText === 'Save and Exit') {
                buttonsArray[i].click();
                return;
            }
        }
    }
}
async function loadExistingPIP(
    iframe,
    pipformid: string,
    showiFrame: boolean,
) : Promise<void> {
    if (pipformid > '') {
        iframe.src = `${window.location.origin}/csp/land-transfer-tax-info?id=${pipformid}`;
        patchPipsIframeJQuery(iframe);
        removeHeaderFooter(iframe,showiFrame);
    }
}

function getPipsConfirmationNumberFromDoc(doc: Document): string | null {
    const titleTd = doc.querySelector('td.mof-section-title');
    if (!titleTd || !titleTd.textContent?.includes('Submit Confirmation')) return null;

    const contentTr = titleTd.parentElement?.nextElementSibling as HTMLTableRowElement | null;
    const boldEl = contentTr?.querySelector('b');
    return boldEl?.textContent?.trim() || null;
}

const Pips = () => {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let teraviewAcc: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'AccountName');
    let username: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'Account');
    let teraviewNumber: string = DataReaderObj.getThirdPartyAccountAttribute('TeranetExpress', 'TVNumber');
    let initialPIPFormID: string = DataReaderObj.getPIPFormID();
    let pipConfirmationNumber: string = DataReaderObj.getPIPConfirmnationNumber();
    const [pipformid, setPipformid] = useState<string>('No form created');
    const [pipConfirmnationNumberState, setPipConfirmnationNumberState] = useState<string>('');
    const [pipConfirmationNumberCreated, setPipConfirmationNumberCreated] = useState<boolean>(false);
    const [isLoggedin, setIsLoggedin] = useState<boolean>(null);
    const [showiFrame, setShowiFrame] = useState<boolean>(false);
    const [showNoResultsFoundError, setShowNoResultsFoundError] = useState<boolean>(false);
    const [attemptedLogin, setAttemptedLogin] = useState<boolean>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const sessionId = useAppSelector((state: lddStateObject) => state.SessionID);

    if (initialPIPFormID !== pipformid && initialPIPFormID !== null) {
        setPipformid(initialPIPFormID);
    }
    if (pipConfirmationNumber !== pipConfirmnationNumberState && pipConfirmationNumber !== null) {
        setPipConfirmnationNumberState(pipConfirmationNumber);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
            removeHeaderFooter(iframe,showiFrame);
            let currentHref: string = iframe.contentWindow.location.href;
            let formidw = iframe.contentWindow.document.getElementById('pinPrefix'); // pin prefix
            const doc = iframe.contentDocument;

            // The confirmation can render at /land-transfer-tax-info-success or, when the form
            // falls back to a native POST, at the bare /land-transfer-tax-info URL — so detect
            // it from the document content instead of the URL
            const confirmationNumber = getPipsConfirmationNumberFromDoc(doc);
            if (confirmationNumber && confirmationNumber !== pipConfirmnationNumberState) {
                // Set the PIPS Confirmation Number when the submission is successful
                DataReaderObj.setPIPConfirmnationNumber(confirmationNumber);
                // Clear the PIPS Form ID when the submission is successful (We don't use it anymore)
                DataReaderObj.setPIPFormID('No form created');
                setPipConfirmnationNumberState(confirmationNumber);
                setPipConfirmationNumberCreated(true);
                runInnerFunction('SetPageDirty', null);
            }

            // Submitting the form POSTs to the bare /csp/land-transfer-tax-info URL; the response
            // (validation errors or the confirmation) is still the MOF form, so keep the iframe
            // visible whenever the document contains MOF sections
            const hasMofContent = !!doc?.querySelector('td.mof-section-title');

            if (
                (currentHref.includes('/csp/land-transfer-tax-info-login-failure'))
                ||
                (currentHref.includes('/csp/land-transfer-tax-info-home'))
                ||
                (!(currentHref.includes('/csp/land-transfer-tax-info?id=')) && !(currentHref.includes('/csp/land-transfer-tax-info-success')) && !(currentHref.includes('/csp/land-transfer-tax-info#')) && !hasMofContent && (formidw === null || formidw === undefined))
            ) {
                setShowiFrame(false);
            } else if((formidw && currentHref.includes('/csp/land-transfer-tax-info?id='))){
                setShowiFrame(false);
                setShowNoResultsFoundError(true);
            } else {
                setShowNoResultsFoundError(false);
                setShowiFrame(true);
            }
            if (currentHref.includes('/csp/land-transfer-tax-info-home')) {
                setIsLoggedin(true);
            } else if (currentHref.includes('/csp/land-transfer-tax-info-login-failure')) {
                setIsLoggedin(false);
            }
        }, 1000);
        return () => clearInterval(interval);
    })

    const handlePrint = () => {
        const iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
        if(showNoResultsFoundError || iframe.clientHeight == 0 ){
            alert('There is no PIPS form or PDF loaded to print.');
            return;
        }
        if (iframe && iframe.contentWindow && iframe.contentDocument) {
            const printTab = window.open(' ', '_blank');
            if (printTab) {
                printTab.document.write(iframe.contentDocument.documentElement.outerHTML);
                printTab.document.close();
                printTab.focus();
                printTab.print();
                printTab.close();
            }
        }
    };
    
    const loadScripts = async () => {
        const loadScript = (src: string) => new Promise<void>((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
          document.body.appendChild(script);
        });
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
      };
      
    const handleDownload = async () => {
        const iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
        if (iframe && iframe.contentWindow) {
            try {
                setIsDownloading(true);
                await loadScripts();        
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                const content = iframeDocument.body;
                const buttonTexts = ['Save and Exit', 'Submit', 'Cancel'];
                const hiddenButtons = Array.from(iframeDocument.querySelectorAll('button'))
                    .filter(button => buttonTexts.includes(button.textContent?.trim() || ''))
                    .map(button => {
                    const originalDisplay = button.style.display;
                    button.style.display = 'none';
                    return { button, originalDisplay };
                    });
                await generatePdfPIPS(
                    content,
                    { contentWidth: 540, contentHeight: 880, xOffset: 10, yOffset: 50 },
                    pipformid ? `${pipformid}_pips_form.pdf` : 'pips_form.pdf'
                );
                hiddenButtons.forEach(({ button, originalDisplay }) => {
                    button.style.display = originalDisplay;
                });
            } catch (error) {
                console.error('Error generating PDF:', error);
            } finally {
                setIsDownloading(false);
            }
        } else {
            console.error('iframe or its content window not found.');
        }
    };

return (
        <>
            {isLoading ? <Loading /> : null}
            <Card>
                <Card.Header>
                    <Card.Title>Prescribed Information for the Purposes of Section 5.0.1 Form (PIPS)</Card.Title>
                    <div>
                        <Button variant= "primary" className="me-2" onClick={handlePrint} disabled={!showiFrame||showNoResultsFoundError||!pipConfirmnationNumberState}>
                            Print
                        </Button>
                        {/* <Button variant="primary" onClick={handleDownload} disabled={!showiFrame || isDownloading}>
                            {isDownloading ? 'Downloading...' : 'Download'}
                        </Button> */}
                    </div>
                </Card.Header>

                <Card.Body>
                    <Row>
                        <Col>
                            <Alert>Submitting and opening of forms may take a few minutes to load. After loading, the form will appear to complete the submission process. Please note that this integration is only available during <a href="https://www.teraview.ca/en/hours-of-service/" target="_blank" rel="noopener noreferrer">Teraview<sup>&#174;</sup>'s hours of service</a></Alert>
                        </Col>
                    </Row>
                    {
                        (teraviewAcc <= '' || teraviewAcc === null || teraviewAcc === undefined)
                            ||
                            (username <= '' || username === null || username === undefined)
                            ||
                            (teraviewNumber <= '' || teraviewNumber === null || teraviewNumber === undefined)
                            ?
                            <Row>
                                <Col>
                                    <Alert variant="danger">Your Teraview<sup>&#174;</sup> credentials are incorrect. Please review this in User Settings and Connected Accounts.</Alert>
                                </Col>
                            </Row>
                            :
                            null
                    }
                    {
                        showNoResultsFoundError ?
                            <Alert variant="danger">The form number could not be found. Please create a new form.</Alert>
                            :
                            null}
                    {
                        isLoggedin ?
                            <>
                                <Row>
                                    <Col className="col-4">
                                        <Form.Group>
                                            <Form.Label>PIPS Form ID</Form.Label>
                                            <Form.Control id="PIPFormIDInput" value={pipformid} disabled></Form.Control>
                                            <span className="d-inline-block me-2 mt-2">
                                                <Button
                                                    disabled={pipformid === 'No form created'}
                                                    onClick={() => {
                                                        let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                                        saveAndExit(iframe);
                                                        loadExistingPIP(iframe, pipformid, showiFrame);
                                                    }}>
                                                    Open
                                                </Button>
                                            </span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip id="tooltip-create-new">
                                                        Creating a new PIPS form will discard the current PIPS Confirmation Number
                                                    </Tooltip>
                                                }
                                            >
                                                <span className="d-inline-block me-2 mt-2">
                                                    <Button
                                                        disabled={pipformid !== 'No form created'}
                                                        onClick={async () => {
                                                            setIsLoading(true);

                                                            // Clear any existing confirmation number when starting a new form
                                                            DataReaderObj.setPIPConfirmnationNumber('');
                                                            setPipConfirmnationNumberState('');
                                                            setPipConfirmationNumberCreated(false);

                                                            var ret = await initPips(sessionId, dataRoot);
                                                            if (ret !== undefined) {
                                                                setPipformid(ret);
                                                            }
                                                            let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                                            saveAndExit(iframe);
                                                            loadExistingPIP(iframe, ret, showiFrame);
                                                            setIsLoading(false);
                                                        }
                                                        }>
                                                        Create New
                                                    </Button>
                                                </span>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip id="tooltip-recreate">
                                                        Recreating a PIPS form will discard the current PIPS form
                                                    </Tooltip>
                                                }
                                            >
                                                <span className="d-inline-block me-2 mt-2">
                                                    <Button
                                                        disabled={pipformid === 'No form created'}
                                                        onClick={async () => {
                                                            setIsLoading(true);

                                                            // Clear any existing confirmation number when starting a new form
                                                            DataReaderObj.setPIPConfirmnationNumber('');
                                                            setPipConfirmnationNumberState('');
                                                            setPipConfirmationNumberCreated(false);

                                                            var ret = await initPips(sessionId, dataRoot);
                                                            if (ret !== undefined) {
                                                                setPipformid(ret);
                                                            }
                                                            let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                                            saveAndExit(iframe);
                                                            loadExistingPIP(iframe, ret, showiFrame);
                                                            setIsLoading(false);
                                                        }
                                                        }>
                                                        Recreate
                                                    </Button>
                                                </span>
                                            </OverlayTrigger>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                            :
                            null
                    }
                    {
                        isLoggedin === false && attemptedLogin ?
                            <Alert variant="danger">
                                Your Teraview<sup>&#174;</sup> credentials are incorrect. Please verify that the TV Number is correct.
                            </Alert> :
                            null
                    }
                    {
                        pipConfirmnationNumberState !== '' && pipConfirmnationNumberState !== null && pipConfirmnationNumberState !== undefined ?
                            // true ?
                            <>
                                <Form.Group>
                                    <Form.Label>PIPS Confirmation Number</Form.Label>
                                    <Form.Control id="PIPConfirmnation" value={pipConfirmnationNumberState} disabled />
                                </Form.Group>

                                {/* Only show the warning while the submission confirmation is on screen
                                    (pipConfirmationNumberCreated is only set when the confirmation is captured this session) */}
                                {pipConfirmationNumberCreated && showiFrame ?
                                    <Alert variant={'warning'}>
                                        Please save the document on the screen below and LDD file before proceeding. Otherwise, you will lose the PIPS confirmation number and the document will be lost.
                                    </Alert>
                                    :
                                    null}

                            </>
                            :
                            null
                    }

                    <iframe
                        title="pipScreen"
                        id="pipScreen"
                        src={`${window.location.origin}/csp/land-transfer-tax-info-logout`}
                        style={{
                            width: '100%',
                            overflow: 'auto',
                            height: showiFrame && (showNoResultsFoundError !== true) ? '2400px' : '0px',
                        }}
                        scrolling={"no"}
                        onLoad={async () => {
                            if (!isLoggedin) {
                                let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                await login(iframe, username, teraviewNumber, setAttemptedLogin);
                            }
                        }
                        }
                        onBlur={
                            () => {
                                runInnerFunction('SetPageDirty', null);
                            }
                        }
                    >
                    </iframe>
                </Card.Body>
            </Card>
        </>
    )
}

export default Pips;